import dayjs from "dayjs";

export const detailsFill = ({
  form,
  directors,
  setCheckIndianNationality,
  setPanDoc,
  setAadDoc,
  setFilesAdded,
}) => {
  let name = form.getFieldValue("name");
  if (name) {
    directors.forEach((item) => {
      if (name === item.name) {
        form.setFieldsValue({
          ["firstName"]: item?.firstName ? item?.firstName : item?.name,
          ["lastName"]: item?.lastName,
          ["pan"]: item?.panNumber,
          ["motherName"]: item?.motherName,
          ["Fathername"]: item?.fatherName,
          ["emailId"]: item?.emailId,
          ["mobile"]: item?.phoneNumber,
          ["gender"]: item?.gender,
          ["dob"]: item?.dob ? dayjs(item?.dob, "DD/MM/YYYY") : "",
          ["Nationality"]: item?.nationality,
          ["addressLineOne"]: item?.address?.addressLineOne,
          ["addressLineTwo"]: item?.address?.addressLineTwo,
          ["city"]: item?.address?.city,
          ["country"]: item?.address?.country,
          ["state"]: item?.address?.state,
          ["pinCode"]: item?.address?.pinCode,
          ["designation"]: item?.designation,
        });
        setCheckIndianNationality(
          item.nationality === "Indian" || item.nationality === "IN"
            ? true
            : false
        );
        let files_ = [];
        if (item?.docs?.length) {
          item?.docs?.forEach((elem) => {
            if (elem.type === "DIRECTOR_PAN") {
              let fileName = elem?.s3Url.split("/");
              fileName = fileName[fileName.length - 1];
              let doc_ = {
                type: "AUTHORIZED_SIGNATORY_PAN",
                documentType: "AUTHORIZED_SIGNATORY_PAN",
                name: fileName,
                copyOfOldDoc: true,
                //s3Url: elem?.s3Url
                url: elem?.s3Url,
              };
              setPanDoc(doc_);
              files_.push(doc_);
            } else if (elem.type === "DIRECTOR_ADHAAR") {
              let fileName = elem?.s3Url.split("/");
              fileName = fileName[fileName.length - 1];
              let doc_ = {
                type: "AUTHORIZED_SIGNATORY_ADHAAR",
                documentType: "AUTHORIZED_SIGNATORY_ADHAAR",
                name: fileName,
                copyOfOldDoc: true,
                //s3Url: elem?.s3Url
                url: elem?.s3Url,
              };
              setAadDoc(doc_);
              files_.push(doc_);
            }
          });
        }
        if (files_.length) {
          setFilesAdded(files_);
        }
        return;
      }
    });
  }
  if (
    name &&
    (!directors.length || directors.some((ele) => ele.name !== name))
  ) {
    let firstName = name?.split(" ")[0];
    let lastName = name?.slice(firstName.length).trim();

    form.setFieldsValue({
      ["firstName"]: firstName,
      ["lastName"]: lastName ? lastName : "",
    });
  }
};
